import { useEnvironment } from '@publicisgroupe/p-os-components/build/contexts/EnvironmentContext';
import { Icon } from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import { t } from '../../utils/resources';

type DashboardMobileFilterSectionProps = {
  showFilterOptions: boolean;
  filter: string;
  previousFilter: string;
  nextFilter: string;
  filterOptions: string[];
  activeOption: string;
  handleSelectedOption: (selectedOption: string, filter: string) => any;
  navigateToFilters: (filter: string) => any;
  traverseNextSection: () => any;
  traversePrevSection: () => any;
  saveFiltersAndRedirect: () => any;
  filterKeys: string[];
};

export const DashboardMobileFilterSection = (props: DashboardMobileFilterSectionProps) => {
  const { settings } = useEnvironment();
  return (
    <>
      <div
        className="filter-options"
        style={{
          display: `${props.showFilterOptions ? 'block' : 'none'}`,
          background: `url(${settings.cdnBaseUrl}/webframe/mobile-dashboard-bg.png)`,
        }}
      >
        <div className="filters-wrapper">
          <header className="page-header">
            <div className="fitler-back-button">
              <Icon
                className="pos arrow-left filter-back-arrow"
                size="large"
                onClick={() => props.navigateToFilters(props.filter)}
              />
            </div>
            <div className="section">
              <p className="title">{props.filter}</p>
            </div>
          </header>

          <div className="content">
            <div className="options-section">
              {props.filterOptions.length > 0 &&
                props.filterOptions.map((option: any) => (
                  <div
                    key={`option-${uuidv4()}`}
                    className={`dropdown-item ${
                      props.activeOption === option ? 'selected-dropdown-item' : ''
                    }`}
                    onClick={() => props.handleSelectedOption(option, props.filter)}
                  >
                    {option}
                  </div>
                ))}
            </div>
          </div>

          <footer className="mobile-dashboard-filter-section-footer">
            <div className="footer-navigation">
              <div>
                {props.previousFilter && (
                  <p className="filter-nav-link" onClick={() => props.traversePrevSection()}>
                    <span>
                      <Icon className="pos arrow-left" size="large" />
                    </span>
                    {props.previousFilter}
                  </p>
                )}
              </div>
              <div className={`region-next-section ${props.activeOption ? '' : 'disable-section'}`}>
                {props.nextFilter && (
                  <p className="filter-nav-link" onClick={() => props.traverseNextSection()}>
                    {props.nextFilter}
                    <span>
                      <Icon className="pos arrow-right" size="large" />
                    </span>
                  </p>
                )}
                {!props.nextFilter && (
                  <p className="filter-nav-link" onClick={() => props.saveFiltersAndRedirect()}>
                    {t('DashboardMobile.Done')}
                    <span>
                      <Icon className="pos check" size="large" />
                    </span>
                  </p>
                )}
              </div>
            </div>
            <div className="dots-navigation">
              {props.filterKeys &&
                props.filterKeys.length > 0 &&
                props.filterKeys.map((key) => (
                  <span
                    key={`filter-dot-${uuidv4()}`}
                    className={`dot ${props.filter === key ? 'dot-bg-white' : ''}`}
                  ></span>
                ))}
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};
